import styled from 'styled-components';

export const StepContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 1.25rem;
  min-height: inherit;
`;

export const CardBody = styled.div`
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
  margin-bottom: 30px;
  background-color: var(--chakra-colors-neutral-0);
  display: flex;
  flex-direction: column;
`;

export const CardTextContainer = styled.div`
  margin-bottom: auto !important;
  margin-top: auto !important;
`;

export const CardTitle = styled.div`
  padding: 0.625rem;
  color: #636463;
  margin-bottom: 0.75rem;
  font-size: 1.75rem;
  font-weight: 500;
  line-height: 1.2;
  display: block;
  margin-block-start: 1rem;
  margin-block-end: 1rem;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  text-align: center;
  word-break: break-word;
`;
export const CardText = styled.p`
  padding: 10px;
  color: #636463;
  margin-top: 0;
  margin-bottom: 1rem;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  text-align: center !important;
  word-wrap: break-word;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
`;

export const NextButton = styled.div`
  background-color: #ea6944 !important;
  border-color: #ea6944 !important;
  width: calc(100% - 24px);
  padding: 12px 10px 12px 10px;
  border-collapse: separate !important;
  border-radius: 70px;
  font-weight: normal;
  letter-spacing: -0.5px;
  line-height: 100%;
  text-align: center;
  text-decoration: none;
  color: var(--chakra-colors-neutral-0);
  display: block;
  margin-top: 3em;
  box-shadow: 0px 5px 8px #dddddd;
  cursor: pointer;
  align-self: flex-end !important;

  :hover {
    color: var(--chakra-colors-neutral-0);
    background-color: #f59088 !important;
    border-color: #f59088 !important;
  }
`;
